import { render, staticRenderFns } from "./ItemsList.vue?vue&type=template&id=22714a40&scoped=true&"
import script from "./ItemsList.vue?vue&type=script&lang=js&"
export * from "./ItemsList.vue?vue&type=script&lang=js&"
import style0 from "./ItemsList.vue?vue&type=style&index=0&id=22714a40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22714a40",
  null
  
)

export default component.exports